import Vue from 'vue';
// import News from '../components/News.vue'
import Dialog from '../components/Dialog.vue';
import Snackbar from '../components/Snackbar.vue';
import Game from '../components/Game.vue';
// import Tech from '../components/Tech.vue'
import { toggleGameArea, handleResize, shouldShowGameArea, isMobile, handleScroll, counterObserver } from '@/utils/toggleNavbar.js';
import { mapMutations, mapState } from 'vuex';
export default Vue.extend({
    name: 'Home',
    inject: ['reload'],
    provide() {
        return {};
    },
    components: {
        // News,
        Snackbar,
        Dialog,
        Game
        // Tech
    },
    data() {
        return {
            pageName: 'News',
            filterClassNow: 0,
            // 全部公告
            filterClasses: [
                // 新游戏上线
                {
                    value: 1,
                    key: 'CLASS_1'
                },
                {
                    value: 2,
                    key: 'CLASS_2'
                }
            ],
            filterPlatformNow: 'all',
            filterPlatforms: [
                {
                    value: 'ag',
                    key: 'AG'
                },
                {
                    value: 'xin',
                    key: 'XIN'
                },
                {
                    value: 'yoplay',
                    key: 'YOPLAY'
                },
                {
                    value: 'hunter',
                    key: 'HUNTER'
                }
            ],
            showBg: 0,
            hideAfter: false,
            isGameAreaVisible: true,
            isMobile: isMobile(),
            resizeHandler: null
        };
    },
    computed: {
        ...mapState('common', ['dialog', 'menuItems', 'lang', 'langList']),
        ...mapState('auth', ['isLogin', 'loginUser']),
        ...mapState('news', ['sourceTargetKey']),
        showGameAreaComputed() {
            // console.log('home shouldShow', shouldShowGameArea(this))
            return shouldShowGameArea(this);
        }
    },
    mounted() {
        this.$nextTick(); // 等 DOM render 完
        this.resizeHandler = () => handleResize(this);
        this.scrollHandler = () => handleScroll(this);
        window.addEventListener('scroll', () => {
            const scrolled = window.pageYOffset;
            const heroBackground = document.querySelector('.hero-background');
            if (heroBackground) {
                heroBackground.style.transform = `translateY(${scrolled * 0.5}px)`;
            }
        });
        counterObserver();
        const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
        const navMenu = document.querySelector('.right-side');
        mobileMenuToggle.addEventListener('click', () => { navMenu.classList.toggle('active'); mobileMenuToggle.classList.toggle('active'); });
        window.addEventListener('resize', this.resizeHandler);
        window.addEventListener('scroll', this.scrollHandler, { passive: true });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resizeHandler);
        window.removeEventListener('scroll', this.scrollHandler);
    },
    methods: {
        ...mapMutations('common', ['ChangeDialog', 'ChangeState']),
        changeLang(item) {
            this.ChangeState({ key: 'lang', val: item.key });
            this.reload();
        },
        handlePlatformChange(val) {
            // console.log('Platform changed:', val)
            this.showBg = val;
            this.hideAfter = (val !== 3);
        },
        showGameArea() {
            toggleGameArea(this);
            console.log('showGameArea', this.isGameAreaVisible);
        },
        goToSection(id) {
            const el = document.getElementById(id);
            // console.log(el, id)
            if (!el)
                return;
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }
});
